export default {
  en: {
    BULK_TAGS_TEXT: 'Bulk Tags:',
    ROUTER_FILTER_ADD_AND: 'Add AND rule',
    ROUTER_FILTER_ADD_OR: 'Add OR rule',
    ROUTER_FILTER_AND: 'and',
    ROUTER_FILTER_CONDITION: 'Condition',
    ROUTER_FILTER_OR: 'or',
    ROUTER_TAG_SELECT_PH: 'Select Tag',
    ROUTER_TAG_COMPARE_PH: 'Select operator',
    ROUTER_TAG_SELECT_STATES_PH: 'Search Selected States',
    ROUTER_TAG_SEARCH_STATES_PH: 'Search States',
    ROUTER_VALUE_PH: 'Enter Value',
    ROUTER_FILTER_VALUE_PH: 'Select Filter Value',
    SELECT_FILTER: 'Select Filter',
    SEARCH_FILTER: 'Search Filter',
    FILTER_TEXT: 'Filter',
    EDIT_FILTERS: 'Edit filters',
    DELETE_CRITERIA: 'Delete criteria',
    SELECT_BULK_MODIFIER_PH: 'Select list of modifiers',
    CAMPAIGN_WARNING_FILE_ALREADY_EXISTS_PREFIX: 'A file with these values already exists: ',
    CAMPAIGN_WARNING_FILE_ALREADY_EXISTS_SUFFIX: '. To prevent duplication, Ringba will proceed with the existing file.'
  }
};
